import React from 'react'

export default ({ message, ...rest }) => {
  return (
    <div className="empty" {...rest}>
      <span>{message || 'Nothing to show here.'}</span>
    </div>
  )
}
